import type React from "react";
import type { CardContent } from ".";

interface CardComponentProps {
  cardContent: CardContent;
  onClick?: () => void;
}

export const CardComponent: React.FC<CardComponentProps> = ({ cardContent, onClick }) => {
  return (
    <div
      className="relative flex items-center justify-center w-[179px] h-[142px] rounded-md cursor-not-allowed"
      onClick={onClick}
    >
      <div className="w-full h-full flex flex-col items-center">
        <div className="h-[149px] overflow-y-hidden w-full flex flex-col items-center border-t border-r border-l border-disabled border-solid rounded-t-md">
          {cardContent.heading ? (
            <>
              <h3 className="font-bold text-sm -tracking-[.01em] px-1 pt-2">{cardContent.heading}</h3>
              <div className="h-full w-full flex items-center justify-center">
                <img
                  src={cardContent.src}
                  alt="ad"
                  className={`w-[${cardContent.imageSize.width}px] h-[${cardContent.imageSize.height}px]`}
                />
              </div>
            </>
          ) : (
            <img
              src={cardContent.src}
              alt="ad"
              className={`w-[${cardContent.imageSize.width}px] h-[${cardContent.imageSize.height}px]`}
            />
          )}
        </div>
        <div className="h-[30px] w-full flex items-center justify-center bg-[#01A4F9] py-1 px-1 rounded-b-md flex-auto">
          <p className="text-white font-semibold text-xs">
            {cardContent.limit.lte}円分 - {cardContent.limit.ste}円分
          </p>
        </div>
      </div>
      {/* {showComingSoon()} */}
    </div>
  );
};
